import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { messageClear } from "../store/reducers/authReducer"; /*obtneerr la url de envio*/
import toast from "react-hot-toast";
import { FadeLoader } from "react-spinners";
import { FaStore, FaClock, FaMapMarkedAlt } from "react-icons/fa";

const NuestrasTiendas = () => {
  const navigate = useNavigate();
  const { loader, errorMessage, successMessage } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }

  }, [successMessage, errorMessage,  dispatch, navigate]);

  const storeHours = [
    { day: "Lunes", hours: "10:30 a 21:30 hrs." },
    { day: "Martes", hours: "10:30 a 21:30 hrs." },
    { day: "Miércoles", hours: "10:30 a 21:30 hrs." },
    { day: "Jueves", hours: "10:30 a 21:30 hrs." },
    { day: "Viernes", hours: "10:30 a 21:30 hrs." },
    { day: "Sábado", hours: "10:30 a 21:30 hrs." },
    { day: "Domingo", hours: "10:30 a 21:30 hrs." },
  ];

  const stores = [
    {
      name: "TEKOS - JR. DE LA UNION NRO. 755, CERCADO DE LIMA LIMA",
      address: "JIRON DE LA UNION Nro. 755, CERCADO DE LIMA, LIMA",
      mapUrl: "https://tekos.pe/mapa-jiron755/",
    },
    {
      name: "TEKOS - AV. CHIMPU OCLLO LOTE. 2 URB. TUNGASUCA, CARABAYLLO, COMAS",
      address: "AV. CHIMPU OCLLO LOTE. 2 URB. TUNGASUCA, CARABAYLLO",
      mapUrl: "https://tekos.pe/mapa-qatuna/",
    },
    {
      name: "TEKOS - MARIANO CONDORCANQUI, CARABAYLLO, COMAS",
      address: "AVENIDA MARIANO CONDORCANQUI MZ R1 LOTE 22, CARABAYLLO",
      mapUrl: "https://tekos.pe/mapa-mcondorcanqui/",
    },
    {
      name: "TEKOS - ANTUNEZ DE MAYOLO, LOS OLIVOS",
      address: "AVENIDA ANTUNEZ DE MAYOLO 1379, LOS OLIVOS",
      mapUrl: "https://tekos.pe/mapa-antunez/",
    },
    {
      name: "TEKOS - GRAN CHIMU, ZARATE, SJL",
      address: "AVENIDA GRAN CHIMU 265 - ZARATE",
      mapUrl: "https://tekos.pe/mapa-chimu/",
    },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {loader && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-20">
          <FadeLoader color="#EF4444" />
        </div>
      )}

      <Header />

      <main className="flex-grow py-8 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          {/* Título */}
          <div className="text-center mb-10">
            <h1 className="text-3xl font-bold text-gray-900 sm:text-4xl">BUSCA TU TIENDA MÁS CERCANA</h1>
          </div>

          {/* Listado de tiendas */}
          <div className="space-y-8">
            {stores.map((store, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="p-6 sm:p-8">
                  <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
                    {/* Columna 1: Nombre de tienda */}
                    <div className="flex items-start space-x-4">
                      <FaStore className="flex-shrink-0 mt-1 text-red-500 text-2xl" />
                      <p className="text-red-500 font-medium text-lg">{store.name}</p>
                    </div>

                    {/* Columna 2: Dirección */}
                    <div className="flex items-start">
                      <p className="text-gray-700">{store.address}</p>
                    </div>

                    {/* Columna 3: Horario */}
                    <div>
                      <ul className="space-y-2">
                        {storeHours.map((hour, i) => (
                          <li key={i} className="flex items-start space-x-2">
                            <FaClock className="flex-shrink-0 mt-1 text-red-500 text-sm" />
                            <span className="text-gray-700 font-medium">
                              {hour.day} de {hour.hours}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* Botón Ver Mapa */}
                  <div className="mt-6 text-center">
                    <a
                      href={store.mapUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 transition-colors duration-200">
                      <FaMapMarkedAlt className="mr-2" />
                      VER MAPA
                    </a>
                  </div>
                </div>

                {/* Separador entre tiendas (excepto la última) */}
                {index < stores.length - 1 && <div className="border-t border-gray-200"></div>}
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NuestrasTiendas;
